import { begriffBezeichnung, globalsBezeichnung } from "@/local";
import { EditControlProps, valueChanged } from "./EditComponentStatic";
import { Globals } from "@/Globals";
export declare interface EditComboboxControlProps extends EditControlProps {
    query?: string;
    initValue?: any;
    initStichtag?: string;
    initPassValue?: string;
    aic?: number;
    lastValue?: any;
    queryColumn?: DataColumn;
    queryZeitbereich?: APIZeitbereich;
    openFromDialog?: boolean;

    textKennung?: string;
    fireOnText?: boolean;
    barcodeEnabled?: boolean;
    clearable?: boolean;
    dark?: boolean;
    austrittLaden?: boolean;
    selectedItem?: number;
    barcodePrompt?: string;
    loadFavorite?: boolean;
    // hierarchie:
    sttVon?: number;
    sttBis?: number;
    aicRolle?: number;
    noSerach?: boolean;
    autofocus?: boolean;
    title?: string;
}


export declare interface EditComboboxItemControlProps extends EditControlProps {
    item: EditComboboxItemData,
    columns: DataColumn[];
    favColumn?: DataColumn;
    visibleColumns?: DataColumn[];
    percent?: number;
}

export interface EditComboboxItemData {
    aic?: number;
    description?: string;
    isHeader?: boolean;
    row?: any[];
    bezeichnung?: string;
    percent?: number;
    barcode?: any;
}

export const iconFav: string = "mdi-heart";
export const iconNoFav: string = "mdi-heart-outline";

export declare interface EditComboBoxItemUiData extends EditorControlUiData {
    rowData?: QueryDataRow;
    description: string;
    favColumn?: DataColumn;
    favVal: 0 | 1 | 2;
    favIcon: "favorite" | "favorite_border";
    percent?: number;
}

const nullElement: EditComboboxItemData = {
    description: globalsBezeichnung(
        Globals.Begriff,
        "Web_Bitte_waehlen",
        "Bitte wählen"
    )
};

export declare interface EditComboBoxUiData extends EditorControlUiData {
    rowData: any[];
    description: string;
    selected?: EditComboboxItemData; // duplette ?
    showSettings?: boolean;
    showLoading?: boolean;

    visibleColumns?: DataColumn[];
    columns?: DataColumn[];
    favColumn: DataColumn;

    items: EditComboboxItemData[];
}